import Base from './base'

export default class Prospect extends Base {
  list(params: object) {
    return this.apiClient.get('prospects', params)
  }

  getPipelineMetrics() {
    return this.apiClient.get('prospects/pipeline-metrics')
  }

  create(data: object) {
    return this.apiClient.post('prospects', data)
  }

  show(id: string) {
    return this.apiClient.get(`prospects/${id}`)
  }

  /** Permanently deletes a never-funded prospect, by its client id. */
  delete(clientInfoId: string) {
    return this.apiClient.delete(`prospects/${clientInfoId}`)
  }

  showFoldersInfo(id: string) {
    return this.apiClient.get(`prospects/${id}/folders`)
  }

  overviewFeed(id: string) {
    return this.apiClient.get(`prospects/${id}/overview-feed`)
  }

  draftSchedulingEmail(id: string) {
    return this.apiClient.post(`prospects/${id}/draft-scheduling-email`)
  }

  update(id: string, data: object) {
    return this.apiClient.patch(`prospects/${id}`, data)
  }

  startReporting(id: string, data?: object) {
    return this.apiClient.post(`prospects/${id}`, data)
  }

  updateReporting(id: string, data: object) {
    return this.apiClient.put(`prospects/${id}`, data)
  }

  updateLostDealNotes(id: string, data: { notes: string }) {
    return this.apiClient.put(`prospects/${id}/lost-deal-notes`, data)
  }

  listInventory(id: string, params: object = {}) {
    return this.apiClient.get(`prospects/${id}/inventory`, params)
  }

  listArSummary(id: string, params?: object) {
    return this.apiClient.get(`prospects/ar/summary/${id}`, params)
  }

  updateArSummary(id: string, data: object) {
    return this.apiClient.put(`prospects/ar/summary/${id}`, data)
  }
  listApSummary(id: string, params?: object) {
    return this.apiClient.get(`prospects/ap/summary/${id}`, params)
  }
  updateDate(data: object) {
    return this.apiClient.put(`prospects/date`, data)
  }
  getDate(data: object) {
    return this.apiClient.get(`prospects/date`, data)
  }
  updateFinancialsDates(data: object) {
    return this.apiClient.put(`prospects/financials-dates`, data)
  }
  listProspectReporting(data: object) {
    return this.apiClient.get(`prospects/reporting`, data)
  }
  pullReports(id: string, params?: object) {
    return this.apiClient.get(`prospects/${id}/reports`, params)
  }
  createProspectTerms(id: string, data: object) {
    return this.apiClient.post(`prospects/${id}/terms`, data)
  }
  updateProspectTerms(id: string, prospectTermsId: string, data: object) {
    return this.apiClient.put(`prospects/${id}/terms/${prospectTermsId}`, data)
  }
  listProspectTerms(id: string) {
    return this.apiClient.get(`prospects/${id}/terms`)
  }
  deleteProspectTerms(id: string, prospectTermsId: string) {
    return this.apiClient.delete(`prospects/${id}/terms/${prospectTermsId}`)
  }
  generateTermSheet(id: string, prospectTermsId: string) {
    return this.apiClient.get(`prospects/${id}/terms/${prospectTermsId}/termsheet`)
  }

  updateReportingFlowAdditionalData(id: string, flowId: string, data: object) {
    return this.apiClient.put(`prospects/${id}/${flowId}`, data)
  }

  rename(id: string, name: string) {
    return this.apiClient.post(`prospects/${id}/rename`, { name })
  }

  showInventorySummaryInfo(id: string) {
    return this.apiClient.get(`prospects/${id}/summary/inventory`)
  }

  showCashFlowSummaryInfo(id: string, params: object) {
    return this.apiClient.get(`prospects/${id}/summary/cash-flow`, params)
  }

  showTermStructureSummaryInfo(id: string) {
    return this.apiClient.get(`prospects/${id}/summary/term-structure`)
  }
  createNewOps(id: string, data: object) {
    return this.apiClient.post(`prospects/${id}/new-ops`, data)
  }
  submitOps(id: string, data: object) {
    return this.apiClient.post(`prospects/${id}/submit-ops`, data)
  }
  processFile(opsReportingId: string, fileId: string, isExplicitProcessing: boolean = false) {
    return this.apiClient.post(`prospects/${opsReportingId}/process-file`, {
      fileId,
      opsReportingId,
      isExplicitProcessing,
    })
  }
  processFiles(opsReportingId: string, fileIds: string[], isExplicitProcessing: boolean = false) {
    return this.apiClient.post(`prospects/${opsReportingId}/process-files`, {
      fileIds,
      isExplicitProcessing,
    })
  }
  stopFlowProcessing(opsReportingId: string, flowId: string) {
    return this.apiClient.post(`prospects/${opsReportingId}/stop-flow-processing`, {
      flowId,
    })
  }
  stopFileProcessing(opsReportingId: string, fileId: string) {
    return this.apiClient.post(`prospects/${opsReportingId}/stop-file-processing`, {
      fileId,
    })
  }
}
